import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import { Tooltip } from "@mui/material";
import classNames from "classnames";
import { SmallBody, TinyBody } from "helpers/TypographyComponents";
import { formatLocaleDateString } from "helpers/utils";
import { useCompanySettings } from "hooks/useCompanySettings";
import { useTranslation } from "react-i18next";
import type { AgreementSigner } from "store/agreementsStore";
import { AgreementSignatureStatus } from "store/agreementsStore";

interface IInlineSigner {
    signer: AgreementSigner;
}

const InlineSigner = ({ signer }: IInlineSigner) => {
    const [t] = useTranslation();
    const { companyInfos } = useCompanySettings();
    const deletedUser = !signer.email;

    const signatoryStatus = (signedAt: Date | null) => ({
        [AgreementSignatureStatus.TO_SIGN]: {
            icon: <></>,
            tooltip: "",
        },
        [AgreementSignatureStatus.SENT]: {
            icon: <MoreHorizOutlinedIcon />,
            tooltip: t("ContractValidation.Statussent"),
        },
        [AgreementSignatureStatus.SIGNED]: {
            icon: <CheckOutlinedIcon />,
            tooltip: `${t("ContractValidation.SignedOn")} ${formatLocaleDateString({
                date: signedAt as Date,
                options: { numeric: true, timeZone: "UTC" },
            })} à `,
        },
    });

    const getSignerName = () => {
        if (!signer.email) return t("ContractValidationEdit.DeactivatedUser");
        return `${signer?.firstname ?? ""} ${signer?.lastname ?? ""}`;
    };

    return (
        <div key={`signer-${signer.relatedResourceId}`} title={getSignerName()}>
            <Tooltip title={signatoryStatus(signer?.signedAt)[signer.signedStatus].tooltip}>
                <div className="contract-validation-edit-right-panel-label">
                    <SmallBody
                        className={classNames("signer-name", {
                            "deactivated-user": deletedUser,
                        })}
                    >
                        {getSignerName()}
                    </SmallBody>
                    <TinyBody color="grey" style={{ fontWeight: "300" }}>
                        {signer.relatedResource === "user"
                            ? `(${companyInfos?.name ?? ""})`
                            : `(${t("ContractValidationEdit.Author")})`}
                    </TinyBody>
                    <div className="signatory-signed-status-icon">
                        {signatoryStatus(signer.signedAt)[signer.signedStatus].icon}
                    </div>
                </div>
            </Tooltip>
        </div>
    );
};

export default InlineSigner;
